import { render } from "./WaterTank.vue?vue&type=template&id=4da12719&scoped=true"
import script from "./WaterTank.vue?vue&type=script&lang=js"
export * from "./WaterTank.vue?vue&type=script&lang=js"

import "./WaterTank.vue?vue&type=style&index=0&id=4da12719&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da12719"]])

export default __exports__